import { render, staticRenderFns } from "./PeriodSales.vue?vue&type=template&id=0b474ba9&"
import script from "./PeriodSales.vue?vue&type=script&lang=ts&"
export * from "./PeriodSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports